module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<span class='icon' data-glyph='info'></span>\n<span class='text'>\n  <div class='tip'>\n    <p>To change the run you're currently viewing select a different run from the chart menu in this poll's visual settings under the \"Results From:\" dropdown menu.</p>\n  </div>\n</span>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
